import React, { useEffect, useRef, useState } from 'react';
import ShowList from './ShowList';
import styles from './ChooseYourShowContent.module.css';

import backIcon from '../icons/back_icn.png';

const ChooseYourShowContent = ({ onBack, isAuthenticated, sendEvent, onOpenAuthModal }) => {
  const contentRef     = useRef(null);
  const scrollInterval = useRef(null);

  const [highlightedShowId, setHighlightedShowId] = useState(null);

  useEffect(() => {
    const params    = new URLSearchParams(window.location.search);
    const concertId = params.get('concertId');
    if (concertId) setHighlightedShowId(Number(concertId));
    window.history.replaceState(null, '', '/');
  }, []);

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    let scrollStep = 1;

    const startAutoScroll = () => {
      scrollInterval.current = setInterval(() => {
        if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
          clearInterval(scrollInterval.current);
          scrollInterval.current = null;
        } else {
          content.scrollTop += scrollStep;
        }
      }, 50);
    };

    startAutoScroll();

    const stopAutoScroll = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel', stopAutoScroll, { passive: true });
      content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
    };

    content.addEventListener('wheel', stopAutoScroll, { passive: true });
    content.addEventListener('touchstart', stopAutoScroll, { passive: true });

    return () => {
      content.removeEventListener('wheel', stopAutoScroll, { passive: true });
      content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      clearInterval(scrollInterval.current);
    };
  }, []);

  const restartAutoScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    clearInterval(scrollInterval.current);
    scrollInterval.current = null;

    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel', stop, { passive: true });
      content.removeEventListener('touchstart', stop, { passive: true });
    };

    content.scrollTop = 0;
    let scrollStep = 1;
    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel', stop, { passive: true });
    content.addEventListener('touchstart', stop, { passive: true });
  };

  return (
    <div className={styles.chooseYourShowContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />

      <h1 className={styles.pageTitle}>Обрати Подію</h1>

      <div className={styles.chooseYourShowContent} ref={contentRef}>
        <ShowList
          highlightedShowId={highlightedShowId}
          restartAutoScroll={restartAutoScroll}
          isAuthenticated={isAuthenticated}
          sendEvent={sendEvent}
	  onOpenAuthModal={onOpenAuthModal}
        />
      </div>
    </div>
  );
};

export default ChooseYourShowContent;

